import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import { QuestionModel } from '../../../shared/model/question.model';
import { QuestionFormModalComponent } from './question-form-modal/question-form-modal.component';
import { ConfirmComponent } from '../../../shared/component/confirm/confirm.component';
import { NotificationModalComponent } from '../../../shared/component/notification-modal/notification-modal.component';
import {MessageComponent} from '../../../shared/component/message/message.component';
import { EmailModel } from '../../../shared/model/email.model';
import { copyQuestion } from '../../utils';
import { QuestionAttachmentModalComponent } from './question-attachment-modal/question-attachment-modal.component';


@Component({
	selector: 'app-question',
	templateUrl: './question.component.html',
	styleUrls: ['./question.component.css']
})
export class QuestionComponent implements OnInit {
  @Input() isEndpointEnabled: number | boolean;
	@Input() questions: QuestionModel[];
	@Input() weightSum;
	@ViewChild(QuestionFormModalComponent) questionFormModal: QuestionFormModalComponent;
	@ViewChild(ConfirmComponent) confirm: ConfirmComponent;
	@ViewChild(MessageComponent) message: MessageComponent;
	@ViewChild(NotificationModalComponent) notificationModal: NotificationModalComponent;
	@ViewChild(QuestionAttachmentModalComponent) attachmentModal: QuestionAttachmentModalComponent
	@Output() saveQuestions = new EventEmitter<QuestionModel[]>();
	questionIndex: number = null;
	activeQuestion: QuestionModel;
	previousQuestion;
	emails: EmailModel[];
	displayAttach: Boolean = false
	constructor() { }

	ngOnInit() {}
	
	selectField = (item: QuestionModel, value: boolean, field: string = 'primary') => field ? item[field] = value : '';

	onCopyQuestionNew(question) {		
		const { id, emails, unconformities, item_order, ...otherProps  } = question;

		// if (emails && emails.toString().includes(','))
		let newQuestion = {
			...otherProps, unconformities: unconformities.map(({QuestionUnconformityEntity, ...otherProps}) => {
				return otherProps
			}), emails: emails && emails.map(({QuestionEmailEntity, ...otherProps}) => {
				return otherProps
			})
		};

		newQuestion.item_order = this.questions.length + 1;

		this.questions.push(copyQuestion(newQuestion, this.questions));
	}

	onCopyQuestion (question) {
		// console.log(question)
		
		const { id, emails, unconformities, item_order, ...otherProps  } = question;

		let newQuestion = {...otherProps, unconformities: unconformities.map(({QuestionUnconformityEntity, ...otherProps}) => {
			return otherProps
		}), emails: emails.map(({QuestionEmailEntity, ...otherProps}) => {
			return otherProps
		})}

		newQuestion.item_order = this.questions.length + 1;

		this.questions.push(copyQuestion(newQuestion, this.questions))
		// console.log(newQuestion)
	}
	openNotificationModal(e) {
		this.notificationModal.display = true;
		this.activeQuestion = e
		this.emails = e.emails
	}
	saveNotifications(e) {
		this.activeQuestion.emails = e.emails
		this.activeQuestion.sendEmail = e.sendMail
		// console.log(e)
	}
	saveAttachments(e) {
		this.activeQuestion.attachment = e[0]
		this.questions[this.questionIndex] = this.activeQuestion
		this.saveQuestions.emit(this.questions)
	}
	onCloseAttachment = () => {
		this.activeQuestion = null
		this.questionIndex = null
		this.attachmentModal.display = false
		this.displayAttach = false
	}
	saveQuestion(e: QuestionModel) {
		// console.log(e)
		let questionWeightSum = this.questions.reduce((acc, crr) => {
			acc +=crr.weight 
			return acc
		}, 0)
		questionWeightSum += e.weight;
		questionWeightSum = Math.round(questionWeightSum * 1e2) / 1e2
		if (this.questionIndex != null) {
			questionWeightSum -= this.questions[this.questionIndex].weight;
			if (!this.weightSumGreaterThan100(questionWeightSum)) {
				this.orderQuestion(e)
				// if (e.id) {
					
				// 	// this.questions[this.questionIndex] = e
				// 	// this.questions[this.questionIndex].description = e.description;
				// 	// this.questions[this.questionIndex].observation = e.observation;
				// 	// this.questions[this.questionIndex].observation_visible = e.observation_visible;
				// 	// this.questions[this.questionIndex].okay_description = e.okay_description;
				// 	// this.questions[this.questionIndex].disapproved_description = e.disapproved_description;
				// 	// this.questions[this.questionIndex].quantitative_description = e.quantitative_description;
				// 	// this.questions[this.questionIndex].descriptive_limit = e.descriptive_limit;
				// 	// this.questions[this.questionIndex].weight = e.weight;
				// } else {
				// 	this.questions[this.questionIndex] = e;
				// }
			}
		} else {
			if (!this.weightSumGreaterThan100(questionWeightSum)) {
				this.orderQuestion(e)
				// this.questions.push(e);
			}
		}
	
	}
	openAttachmentModal (question) {
		this.displayAttach = true
		this.attachmentModal.display = true
		this.activeQuestion = question
		this.attachmentModal.question_attachments = question.attachment ? [question.attachment] : []
		this.attachmentModal.question_name = question.description
		this.attachmentModal.onHide = this.onCloseAttachment
		this.getIndex(question);
	}
	orderQuestion(e) {
		// let teste = this.questions
		// console.log(this.headerItems)
		// console.log(this.questions)
		if (e.item_order > this.questions.length && !this.previousQuestion) {
			this.questions.push(e)
		} else if (this.previousQuestion) {
			if (this.previousQuestion.item_order !== e.item_order) {
				this.questions = this.questions.reduce((acc: QuestionModel[], crr: QuestionModel, i: number) => {
					if (i != this.questionIndex) {
						if (e.item_order < this.previousQuestion.item_order) {
							if(crr.item_order >= e.item_order && crr.item_order < this.previousQuestion.item_order) {
								acc.push({...crr, item_order: crr.item_order+1})
							}
							else 
								acc.push(crr)
						}
						else {
							if(crr.item_order <= e.item_order && crr.item_order > this.previousQuestion.item_order) {
								acc.push({...crr, item_order: crr.item_order-1})
							}
									
							else 
								acc.push(crr)
						}
					} else {
						// console.log(e)
						acc.push(e)
					}
					return acc
				}, [])
				
			}

		} else {
			this.questions = this.questions.reduce((acc: QuestionModel[], crr: QuestionModel, i: number) => {
				if(crr.item_order >= e.item_order)
					acc.push({...crr, item_order: crr.item_order + 1})
				else acc.push(crr)
				return acc
			}, [])
			this.questions.push(e)
		}
		this.questions = _.orderBy(this.questions, 'item_order')
		this.questionIndex = null
		this.previousQuestion = null
		this.questionFormModal.display = false;
		// console.log(this.questions)
		// console.log(this.questions)
		this.saveQuestions.emit(this.questions);
	}
	weightSumGreaterThan100(weightSum) {
		if (weightSum > 100) {
			this.questionFormModal.display = false;
			this.message.error('Não é possível adicionar esta questão, pois excede 100% do peso.');
			return true;
		}
		return false;
	}


	deleteQuestion(question: QuestionModel) {
		this.getIndex(question);
		this.confirm.key = 'question';
		this.confirm.confirm();
	}

	acceptDeleteQuestion() {
		this.questions.splice(this.questionIndex, 1);
		this.questionIndex = null;
		this.saveQuestions.emit(this.questions);
	}

	rejectDeleteQuestion() {
		this.questionIndex = null;
	}

	openQuestionFormModal(data?: QuestionModel) {
		if (data) {
			// console.log(data)
			// console.log(this.questions)
			this.getIndex(data);
			this.previousQuestion = {...data} as QuestionModel
			this.questionFormModal.question = data;
			this.questionFormModal.orderLimit = this.questions.length
		} else {
			this.questionFormModal.question.item_order = this.questions.length + 1
			// this.questionIndex = null;
			// this.headerItemModal.headerItem.itemOrder = this.headerItems.length + 1
			this.questionFormModal.orderLimit = this.questions.length + 1
		}
		this.questionFormModal.display = true;
	}

	getIndex(data) {
		this.questionIndex = this.questions.indexOf(data);
	}

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/question-group/question/question.component.ts